<template
  ><v-container>
    <v-row
      class="align-center"
      style="min-height: 4rem;"
      v-if="this.ownerGuid === $store.state.userData.guid"
    >
      <v-col class="d-flex justify-end">
        <v-btn color="primary" @click="$refs.reflectionsDialog.showDialog()">
          <v-icon left>mdi-plus</v-icon>
          {{ $t("add") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-skeleton-loader
      :loading="loading"
      translate="trans"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    >
      <v-row no-gutters>
        <v-col cols="12">
          <v-card
            v-if="reflections && reflections.length > 0"
            flat
            color="transparent"
            class="pa-0 ma-0"
          >
            <v-card
              outlined
              v-for="(reflection, index) in reflections"
              :key="reflection.reflectionGuid"
              class="my-3"
            >
              <v-card-text>
                <v-row>
                  <profileImage
                    class="ma-2"
                    :thumbnail="true"
                    :displayName="reflection.student.studentFullName"
                    :imageUrl="reflection.student.profileImageUrl"
                  />
                  <v-spacer></v-spacer>

                  <v-chip
                    class="mt-2"
                    small
                    outlined
                    label
                    :title="reflection.createdDate | moment('YYYY/MM/DD - h:mm A')"
                  >
                    {{ dateFromNow(reflection.createdDate) }}
                    <v-icon
                      v-if="reflection.modifiedDate"
                      small
                      class="ms-1"
                      :title="
                        `${$t('portfolio.general.modifiedDate')}: ${$options.filters.moment(
                          reflection.modifiedDate,
                          'YYYY/MM/DD - h:mm A'
                        )}`
                      "
                      >mdi-pencil</v-icon
                    >
                  </v-chip>
                </v-row>
              </v-card-text>
              <v-card-text class="py-1 px-2">
                <h4 dir="auto">{{ reflection.reflectionText }}</h4>
                <v-btn
                  :title="reflection.showFiles ? $t('hideAttachments') : $t('showAttachments')"
                  v-if="reflection.files && reflection.files.length > 0"
                  class="mt-2"
                  small
                  depressed
                  @click="
                    reflection.showFiles = !reflection.showFiles;
                    $forceUpdate();
                  "
                >
                  <v-icon left>mdi-paperclip</v-icon>
                  ({{ reflection.files.length }})
                  <v-icon>
                    {{ reflection.showFiles ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon
                  >
                </v-btn>
                <v-row
                  ><v-col cols="12">
                    <v-spacer></v-spacer>
                    <v-expand-transition>
                      <Attachments
                        :key="reflection.reflectionGuid"
                        v-if="
                          reflection.showFiles && reflection.files && reflection.files.length > 0
                        "
                        :ownerGuid="ownerGuid"
                        :sourceGuid="reflection.reflectionGuid"
                        sourceType="Reflection"
                        v-model="reflection.files"
                        :itemsPerPage="4"
                      />
                    </v-expand-transition> </v-col
                ></v-row>
              </v-card-text>
              <v-card-actions class="d-flex justify-space-between ">
                <div>
                  <v-btn
                    text
                    small
                    @click="
                      currentReflectionGuid = reflection.reflectionGuid;
                      $refs.commentsDialog.showDialog(1, reflection.reflectionGuid);
                    "
                    color="primary"
                  >
                    <v-icon left>mdi-comment</v-icon>
                    {{ $t("portfolio.comment.add") }}
                  </v-btn>
                  <v-btn
                    v-if="isOwner(reflection)"
                    text
                    small
                    @click="$refs.reflectionsDialog.showEditDialog(reflection)"
                    color="primary"
                  >
                    <v-icon left>mdi-pencil</v-icon>{{ $t("edit") }}
                  </v-btn>
                  <v-btn
                    text
                    small
                    v-if="isOwner(reflection)"
                    @click="deleteReflection(reflection)"
                    color="red"
                  >
                    <v-icon left>mdi-delete</v-icon>{{ $t("delete") }}
                  </v-btn>
                  <v-btn
                    text
                    small
                    v-if="isInRole(2)"
                    @click="
                      currentReflectionGuid = reflection.reflectionGuid;
                      $refs.feedbackDialog.showDialog(reflection.reflectionGuid);
                    "
                    color="green"
                  >
                    <v-icon left>mdi-message-text</v-icon>{{ $t("portfolio.Feedback.add") }}
                  </v-btn>
                </div>
              </v-card-actions>

              <v-btn
                v-if="reflection.feedbacks && reflection.feedbacks.length > 0"
                class="ma-2"
                small
                depressed
                @click="
                  reflection.showFeedbacks = !reflection.showFeedbacks;
                  reflection.showComments = reflection.showFeedbacks
                    ? false
                    : reflection.showComments;
                  $forceUpdate();
                "
              >
                <v-icon color="green" left>mdi-message-text</v-icon>
                {{ $t("portfolio.Feedback.plural") }} ({{ reflection.feedbacks.length }})
                <v-icon>
                  {{ reflection.showFeedbacks ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon
                >
              </v-btn>

              <v-btn
                v-if="reflection.comments && reflection.comments.length > 0"
                class="ma-2"
                small
                depressed
                @click="
                  reflection.showComments = !reflection.showComments;
                  reflection.showFeedbacks = reflection.showComments
                    ? false
                    : reflection.showFeedbacks;
                  $forceUpdate();
                "
              >
                <v-icon color="primary" left>mdi-message</v-icon>
                {{ $t("portfolio.comment.plural") }} ({{ reflection.comments.length }})
                <v-icon>
                  {{ reflection.showComments ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon
                >
              </v-btn>

              <v-expand-transition>
                <Feedbacks
                  v-if="reflection.showFeedbacks"
                  class="mx-4 mb-2"
                  :key="reflection.reflectionGuid"
                  sourceType="1"
                  :sourceGuid="reflection.reflectionGuid"
                  v-model="reflection.feedbacks"
              /></v-expand-transition>

              <v-expand-transition>
                <Comments
                  v-if="reflection.showComments"
                  :key="'comments_' + reflection.reflectionGuid"
                  class="mx-4 mb-2"
                  sourceType="1"
                  :sourceGuid="reflection.reflectionGuid"
                  v-model="reflection.comments"
              /></v-expand-transition>
            </v-card>
          </v-card>
          <NoData v-else-if="!loading" />
        </v-col>
      </v-row>
    </v-skeleton-loader>

    <CommentsDialog ref="commentsDialog" @add="addCommentHandler" />
    <ReflectionsDialog
      :workSampleGuid="workSampleGuid"
      ref="reflectionsDialog"
      @add="addReflectionHandler"
      @edit="editReflectionHandler"
    />
    <ConfirmActionDialog
      ref="confirmActionDialog"
      @confirm="deleteReflectionHandler"
      :title="$t('portfolio.Reflections.delete')"
      :description="$t('portfolio.Reflections.confirmDelete')"
    />

    <FeedbackDialog ref="feedbackDialog" sourceType="1" @add="addFeedbackHandler" /> </v-container
></template>

<script>
import Comments from "@/components/portfolio/comments/comments.vue";
import DownloadFile from "@/components/downloadFile.vue";
import ConfirmActionDialog from "@/components/confirmActionDialog.vue";
import Feedbacks from "../../../../components/portfolio/feedback/feedbacks.vue";
import CommentsDialog from "../../../../components/portfolio/comments/commentsDialog.vue";
import ReflectionsDialog from "../../../../components/portfolio/reflection/reflectionsDialog.vue";
import FeedbackDialog from "../../../../components/portfolio/feedback/feedbackDialog.vue";
import NoData from "../../../../components/noData.vue";
import LoadingData from "../../../../components/loadingData.vue";
import Attachments from "@/views/dashboard/portfolio/attachment/index.vue";
import profileImage from "../../../../components/portfolio/profileImage.vue";

export default {
  name: "ReflectionTimeline",
  components: {
    Comments,
    Feedbacks,
    CommentsDialog,
    ReflectionsDialog,
    ConfirmActionDialog,
    DownloadFile,
    NoData,
    LoadingData,
    FeedbackDialog,
    Attachments,
    profileImage
  },
  props: {
    ownerGuid: {
      type: String,
      required: true
    },
    workSampleGuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      currentReflectionGuid: null,
      activeReflection: null,
      reflections: []
    };
  },
  async created() {
    this.getReflections();
  },
  methods: {
    isOwner(reflection) {
      return reflection.student.studentGuid === this.$store.state.userData.guid;
    },
    addFeedbackHandler(x) {
      var feedBackList = this.reflections.find(
        ref => ref.reflectionGuid === this.currentReflectionGuid
      );
      if (feedBackList) {
        if (!feedBackList.feedbacks) {
          feedBackList.feedbacks = [];
        }
        feedBackList.feedbacks.unshift(x);
        this.$forceUpdate();
      }
    },
    addReflectionHandler(x) {
      this.reflections.unshift(x);
    },
    editReflectionHandler(x) {
      var showFiles = x.showFiles;
      this.getReflections().then(() => {
        const index = this.reflections.findIndex(ref => ref.reflectionGuid === x.reflectionGuid);
        if (index !== -1) {
          this.reflections[index].showFiles = showFiles;
          this.$forceUpdate();
        }
      });
    },
    deleteReflectionHandler() {
      this.axios
        .post("Reflection/Delete", { reflectionGuid: this.activeReflection.reflectionGuid })
        .then(() => {
          const index = this.reflections.findIndex(
            ref => ref.reflectionGuid === this.activeReflection.reflectionGuid
          );
          if (index !== -1) {
            this.reflections.splice(index, 1);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteReflection(x) {
      this.activeReflection = x;
      this.$refs.confirmActionDialog.showDialog();
    },
    addCommentHandler(x) {
      var commentList = this.reflections.find(
        ref => ref.reflectionGuid === this.currentReflectionGuid
      );
      if (commentList) {
        if (!commentList.comments) {
          commentList.comments = [];
        }
        const index = commentList.comments.findIndex(c => c.commentGuid === x.commentGuid);
        if (index !== -1) {
          commentList.comments[index].commentText = x.commentText;
        } else {
          commentList.comments.unshift(x);
        }
        this.$forceUpdate();
      }
    },
    async getReflections() {
      this.loading = true;
      await this.axios
        .get("Reflection/Get", { params: { workSampleGuid: this.workSampleGuid } })
        .then(res => {
          this.reflections = res.data.data;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 0);
        });
    }
  }
};
</script>
